import { requireNodeEnvVar } from "../server/utils";

interface ApiConfig {
  baseUrl: string;
  isMock: boolean;
}

export const apiConfig: ApiConfig = {
  baseUrl: requireNodeEnvVar("BACKEND_SERVICE_URL"),
  isMock: false
};